import { App } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";

import { socket } from "./network.js";

function reconnect(): void {
  if (!socket.connected) socket.connect();
  window.dispatchEvent(new Event("resize"));
}

export async function registerNativeLifecycle(): Promise<void> {
  const platform = Capacitor.getPlatform();
  document.documentElement.dataset["platform"] = platform;
  document.documentElement.classList.toggle("is-native", Capacitor.isNativePlatform());

  window.addEventListener("online", reconnect);
  window.addEventListener("orientationchange", () => window.dispatchEvent(new Event("resize")));

  if (Capacitor.isNativePlatform()) {
    await App.addListener("appStateChange", ({ isActive }) => {
      if (isActive) reconnect();
    });
    await App.addListener("resume", reconnect);
  }
}
